// extracted by mini-css-extract-plugin
export default {"button":"expand-button-module__button--bQ7Ee","expanded":"expand-button-module__expanded--auBfH"};